import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LanguageService } from 'src/app/services/language.service';
import { MessagesService } from 'src/app/services/messages.service';
import { AlertMessageService } from 'src/app/services/alert-message.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  dashboard: any = null;
  sendMessageAdminForm: FormGroup;
  selectedUser: any = {};
  selectedUserTemp: any;
  loading = false;

  constructor(private dashboardService: DashboardService,
    private languageService: LanguageService,
    private messageService: MessagesService,
    private alertMessageService: AlertMessageService) {
    this.dashboardService.getWarehouseDashboard().subscribe((result) => {
      if (result['status']) {
        this.dashboard = result;
      }
      console.log(this.dashboard);
    });
    this.sendMessageAdminForm = new FormGroup({
      message: new FormControl('', Validators.required),
      sendTo: new FormControl('DCV', Validators.required),
      subject: new FormControl(''),
      user: new FormControl(''),
      picker: new FormControl('', Validators.required),
      picker2: new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
  }

  sendMessage() {
    const language = this.languageService.getCurrentLanguage();
    const data = {
      message: this.sendMessageAdminForm.value['message'],
      to_role_name: this.sendMessageAdminForm.value['sendTo'],
      subject: this.sendMessageAdminForm.value['subject'],
      activationDate: this.sendMessageAdminForm.value['picker'],
      expirationDate: this.sendMessageAdminForm.value['picker2'],
      to_user_id: this.selectedUser.id
    };
    console.log(this.sendMessageAdminForm.value);
    if (data.to_role_name === 'LUM' && this.selectedUser.id != null && !this.loading) {
      this.loading = true;
      this.messageService.sendMessageToUser(data).subscribe((result) => {
        this.loading = false;
        const messageCode = result['code'];
        if (result['status'] === true) {
          this.alertMessageService.showSuccessMessage(language, messageCode);
        } else {
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
        this.sendMessageAdminForm.reset();
      }, error => {
        this.loading = false;
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      });
    } else {
      this.messageService.sendMessageToRol(data).subscribe((result) => {
        const messageCode = result['code'];
        console.log(messageCode);
        if (result['status'] === true) {
          this.alertMessageService.showSuccessMessage(language, messageCode);
        }
        else {
          this.alertMessageService.showErrorMessage(language, messageCode);
        }
        this.sendMessageAdminForm.reset();
      }, error => {
        const messageCode = 'CE';
        this.alertMessageService.showErrorMessage(language, messageCode);
      });
    }
  }

}
